import { TherapistAction } from 'src/redux/actions/constant';

const intialState: object = {
  response: null,
  isGetTherapistList: false,
  data: [],
  loading: false,
  localDate: '',
  // THIN-7718: discipline this response was requested for, so consumers can drop a late
  // response belonging to a board the user has already navigated away from.
  discipline: '',
};

export const getTherapistListReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetTherapistList: true,
        data: action.payload.data,
        loading: false,
        localDate: action.payload?.localDate,
        discipline: action.payload?.discipline,
      };
    }
    case TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetTherapistList: false,
        loading: false,
        localDate: action.payload?.localDate,
        discipline: action.payload?.discipline,
      };
    }
    case TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TherapistAction.GET_ALL_THERAPIST_LIST_TYPE_RESET:
      return {
        ...state,
        response: null,
      };
    default:
      return state;
  }
};
